import styled from 'styled-components'
import { TextField } from '@material-ui/core'

const InputField = styled(TextField)`
  margin-top: 0;
  margin-bottom: 24px;
`

export default InputField
